if (!customElements.get('mc-gift-card')) {
  class McGiftCard extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('.mc-gift__form');
      if (!this.form) return;
      this.recipientFields = this.querySelector('[data-recipient-fields]');
      this.dateField = this.querySelector('[data-date-field]');
      this.email = this.form.elements.namedItem('properties[Recipient email]');
      this.sendOn = this.form.elements.namedItem('properties[Send on]');
      this.offset = this.form.elements.namedItem('properties[__shopify_offset]');
      this.offset.value = String(new Date().getTimezoneOffset());
      const localDate = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      const today = new Date();
      const latest = new Date(today);
      latest.setDate(latest.getDate() + 90);
      this.sendOn.min = localDate(today);
      this.sendOn.max = localDate(latest);
      this.form.addEventListener('change', () => this.sync());
      this.form.addEventListener('input', () => this.syncPreview());
      this.form.addEventListener('submit', (event) => this.submit(event));
      this.sync();
    }

    sync() {
      const gifting = this.form.elements.namedItem('gift_delivery').value === 'recipient';
      this.recipientFields.hidden = !gifting;
      this.querySelector('[data-self-hint]').hidden = gifting;
      this.recipientFields.querySelectorAll('input, textarea').forEach((input) => { input.disabled = !gifting; });
      this.email.required = gifting;
      const scheduled = gifting && this.form.elements.namedItem('gift_timing').value === 'scheduled';
      this.dateField.hidden = !scheduled;
      this.sendOn.disabled = !scheduled;
      this.sendOn.required = scheduled;
      const selected = this.form.querySelector('[name="id"]:checked');
      this.querySelector('[data-submit]').disabled = !selected || selected.disabled;
      this.syncPreview();
    }

    syncPreview() {
      const selected = this.form.querySelector('[name="id"]:checked');
      if (selected) {
        this.querySelector('[data-card-amount]').textContent = selected.dataset.formattedPrice;
        this.querySelector('[data-total]').textContent = selected.dataset.formattedPrice;
      }
      const message = this.form.elements.namedItem('properties[Message]').value;
      const note = this.querySelector('[data-card-note]');
      if (!this.defaultNote) this.defaultNote = note.textContent;
      const gifting = this.form.elements.namedItem('gift_delivery').value === 'recipient';
      note.textContent = gifting && message.trim() ? message : this.defaultNote;
      this.querySelector('[data-message-count]').textContent = `${message.length} / 200`;
    }

    async submit(event) {
      event.preventDefault();
      if (this.submitting || !this.form.reportValidity()) return;
      this.submitting = true;
      const button = this.querySelector('[data-submit]');
      const error = this.querySelector('[data-form-error]');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      error.hidden = true;
      const data = new FormData(this.form);
      data.delete('gift_delivery');
      data.delete('gift_timing');
      try {
        const response = await fetch(this.dataset.addUrl, { method: 'POST', body: data, headers: { Accept: 'application/json' } });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || this.dataset.error);
        window.location.assign(this.dataset.cartUrl);
      } catch (cause) {
        error.textContent = cause.message || this.dataset.error;
        error.hidden = false;
        this.submitting = false;
        button.removeAttribute('aria-busy');
        this.sync();
      }
    }
  }
  customElements.define('mc-gift-card', McGiftCard);
}
